function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRegularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.25c-1.345 0-1.992.75-4.2.75s-2.85-.75-4.2-.75a6.3 6.3 0 0 0-6.3 6.3v1.2A2.251 2.251 0 0 0 2.25 24h16.5A2.251 2.251 0 0 0 21 21.75v-1.2a6.3 6.3 0 0 0-6.3-6.3zm4.05 7.5H2.25v-1.2A4.057 4.057 0 0 1 6.3 16.5c.684 0 1.8.75 4.2.75 2.423 0 3.511-.75 4.2-.75a4.057 4.057 0 0 1 4.05 4.05zM10.5 13.5a6.75 6.75 0 1 0-6.75-6.75 6.752 6.752 0 0 0 6.75 6.75zm0-11.25A4.5 4.5 0 1 1 6 6.75a4.507 4.507 0 0 1 4.5-4.5z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRegularIcon);
export default __webpack_public_path__ + "static/media/user-regular-icon.71add3d3.svg";
export { ForwardRef as ReactComponent };